import { api } from '@/services'
import { checklistApi } from '@/services/checklistApi'

export function fetchLinkedAppointmentTypes(params = {}) {
  return api.get('/admin/appointmentTypes/linkedTypesAndChecklists', { params })
}

export function unlinkAppointmentTypeChecklist(id) {
  return api.delete(`/admin/appointmentTypes/unlink/${id}`)
}

export function linkAppointmentTypeChecklist(payload) {
  return api.post('/admin/appointmentTypes/link', payload)
}

export function fetchChecklists(params = {}) {
  return checklistApi.get('/admin/assetReportConfig/list', { params })
}

// With a real estate: the types of its active contract that can get a model of their own for it
export function fetchAppointmentTypes(realEstateId) {
  return api.get('/admin/appointmentTypes/availableTypes', {
    params: realEstateId ? { realEstateId } : {},
  })
}

export function searchRealEstates(search) {
  return api.get('/admin/realEstate/search', {
    params: { page: 0, size: 20, ...(search ? { search } : {}) },
  })
}
